<template>
  <div class="rcw-card">
    <Report
      v-if="template"
      :report-data="template"
      :isolated="true"
      :hide-controls="true"
      :hide-detailed-data="true"
      class="rcw-report"
    />
    <div v-else class="rcw-empty">{{ $t('Assistant.Widget.Unsupported', { type: 'report' }) }}</div>
  </div>
</template>

<script>
import Report from '@/components/reports/Report.vue'

// Renders an assistant-surfaced report exactly like a dashboard report widget: same Report.vue,
// same fetch path (it pulls fresh chart-ready data itself from the template), so chart rendering
// never has to be reimplemented for chat. The agent's report_config only carries
// {source_request, settings} with type_chart nested inside source_request, while Report.vue's
// syncToLocalState reads type/type_chart off the top level — so we promote them here.
export default {
  name: 'ReportChartWidget',
  components: { Report },
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    template() {
      const sr = this.data?.reportConfig?.source_request
      if (!sr) return null
      return {
        type: sr.type,
        type_chart: sr.type_chart,
        source_request: sr,
        settings: this.data.reportConfig.settings,
      }
    },
  },
}
</script>

<style scoped>
.rcw-card {
  width: 100%; min-height: 280px; border: 1px solid var(--ui-border); border-radius: var(--radius-lg);
  background: var(--ui-bg-card);
}
.rcw-report { width: 100%; }
.rcw-empty {
  height: 280px; display: flex; align-items: center; justify-content: center;
  font: 500 12px 'Open Sans', sans-serif; color: var(--ui-text-3);
}
</style>
